import { useId } from 'react';
import { Checkbox } from '@azelis/ui/components/checkbox';
import {
  Field,
  FieldContent,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSet,
} from '@azelis/ui/components/field';

import type { SharePointDocument } from '@/api/types';

/** Checkbox list of documents belonging to a single drive. */
export function DocumentCheckboxList({
  documents,
  onToggle,
  selectedDocumentIds,
}: {
  documents: Array<SharePointDocument>;
  onToggle: (id: string) => void;
  selectedDocumentIds: Array<string>;
}) {
  const listId = useId();

  return (
    <FieldSet>
      <FieldLegend className="sr-only">Documents in this category</FieldLegend>
      <FieldGroup className="gap-6">
        {documents.map((document) => {
          const fieldId = `${listId}-${document.id}`;

          return (
            <Field key={document.id} orientation="horizontal">
              <Checkbox
                checked={selectedDocumentIds.includes(document.id)}
                id={fieldId}
                onCheckedChange={() => {
                  onToggle(document.id);
                }}
              />
              <FieldContent>
                <FieldLabel htmlFor={fieldId}>{document.filename}</FieldLabel>
                {document.countryCodes.length > 0 ? (
                  <FieldDescription>{document.countryCodes.join(', ')}</FieldDescription>
                ) : null}
              </FieldContent>
            </Field>
          );
        })}
      </FieldGroup>
    </FieldSet>
  );
}
